import React, { useState, useEffect } from "react";
import { X, Copy, ExternalLink } from "lucide-react";

export default function InAppBrowserBanner() {
  const [show, setShow] = useState(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const ua = navigator.userAgent || "";
    const isInApp = /FBAN|FBAV|Instagram|FB_IAB|FBIOS|FBSS/i.test(ua);
    if (isInApp) setShow(true);
  }, []);

  if (!show) return null;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Fallback for older browsers
      const input = document.createElement("input");
      input.value = window.location.href;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <div
      className="w-full px-4 py-3 flex items-center justify-between gap-3 flex-wrap"
      style={{ backgroundColor: "var(--color-gold)", color: "var(--color-navy)" }}
      data-testid="in-app-browser-banner"
    >
      <div className="flex items-center gap-2 flex-1 min-w-0">
        <ExternalLink size={16} className="shrink-0" />
        <p className="font-body text-sm font-medium">
          For the best experience uploading photos, open this page in Chrome or Safari.
        </p>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <button
          onClick={handleCopy}
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-[6px] font-body text-xs font-medium transition-colors"
          style={{ backgroundColor: "var(--color-navy)", color: "white" }}
          data-testid="copy-url-btn"
        >
          <Copy size={12} />
          {copied ? "Copied!" : "Copy Link"}
        </button>
        <button
          onClick={() => setShow(false)}
          className="p-1 rounded hover:bg-black/10 transition-colors"
          data-testid="dismiss-banner-btn"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
